<template>
  <div>
    <el-select v-model="selectedOption" placeholder="选择筛选条件" @change="filterResults">
      <el-option
        v-for="option in operationOptions"
        :key="option"
        :label="option"
        :value="option">
      </el-option>
    </el-select>


    <div style="margin-right: 20px; width: 200px;display: inline">

      <div v-for="(sums, groupName) in groupSums" :key="groupName" style="margin-bottom: 10px; border: 1px solid #dcdfe6; padding: 10px;display: grid">
        <strong>{{ groupName }}:</strong>
        <span>今日消费: {{ sums.totalToday }}</span>
        <span>昨日消费: {{ sums.totalYesterday }}</span>

      </div>
    </div>
    <div style="">

      <el-table :data="tableData" border :summary-method="summaryMethod" style="" >
        <el-table-column prop="uname" label="用户名"  style="width: 30%"></el-table-column>
        <el-table-column prop="todayConsume" label="今日消费" style="width: 30%" sortable></el-table-column>
        <el-table-column prop="yesConsume" label="昨日消费" style="width: 30%" sortable></el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>
import * as echarts from "echarts";
import axios from 'axios';

export default {
  name: "EchartDashboard",
  data() {
    return {
      todayAll: [],
      yesAll: [],
      groups: {
        '福建组': ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','福建代运营','詹思城','张爱','黄加龙'],
        '福建1组': ['张栖宇', '林俊杰', '黄祥舟'],
        '福建2组': ['周尚安', '吴周莉', '陈慧','詹思城','张爱','黄加龙'],
        '福建运营代运营组': ['福建代运营']
      },
      users: [
        { uname: '张爱', uaccounts: ['Zhangai01','Zhangai02'] },
        { uname: '黄加龙', uaccounts: ['Hjialong01','Hjialong02'] },
        { uname: '詹思城', uaccounts: ['zhansic01','zhansic02'] },

        { uname: '周尚安', uaccounts: ['zhoushangan01', 'zhoushangan02'] },
        { uname: '郑伏金', uaccounts: ['zhengfujin01'] },
        { uname: '福建追书浙江端口', uaccounts: ['zjfjzs'] },
        { uname: '张栖宇', uaccounts: ['zhangqiyv1', 'zhangqiyv2'] },
        { uname: '叶福顺', uaccounts: ['yefushun1', 'yefushun2'] },
        { uname: '吴周莉', uaccounts: ['wuzhouli01', 'wuzhouli02'] },
        { uname: '翁媚芳', uaccounts: ['wengmeifang1', 'wengmeifang2'] },
        { uname: '生米', uaccounts: ['shengmi', 'shengmi2'] },
        { uname: '千堆雪', uaccounts: ['qianduxue', 'qianduxue3'] },

        { uname: '林俊杰', uaccounts: ['linjunjie01', 'linjunjie02'] },
        { uname: '黄祥舟', uaccounts: ['huangxiangzhou', 'huangxz02'] },
        { uname: '福建追书福建端口', uaccounts: ['fjfjzs'] },
        // { uname: '自运营点众', uaccounts: ['dianzhxs','dianzh'] },
        // { uname: '代运营点众', uaccounts: ['Shaoyong'] },
        { uname: '陈曦', uaccounts: ['zjchenxi', 'chenxi2'] },
        { uname: '陈慧', uaccounts: ['chenhui1', 'chenhui02'] },
        { uname: '福建代运营', uaccounts: ['zjdaiyunying', 'fjdaiyunying'] },
      ],
      result: [],
      tableData: [],
      selectedOption: '全部',
      operationOptions: ['全部', '客户', '运营', '销售','福建组', '福建1组', '福建2组'],
      zjcookie:'',
      fjcookie:''
    };
  },
  created() {
    this.fetchHdCookieData();
  },
  computed: {
    groupSums() {
      const sums = {};
      for (const [groupName, members] of Object.entries(this.groups)) {
        const totalToday = this.result
          .filter(item => members.includes(item.uname))
          .reduce((total, item) => total + Number(item.todayConsume), 0).toFixed(2);
        const totalYesterday = this.tableData
          .filter(item => members.includes(item.uname))
          .reduce((total, item) => total + Number(item.yesConsume), 0).toFixed(2);
        sums[groupName] = { totalToday, totalYesterday };
      }
      return sums;
    },
    totalTodayConsume() {
      return this.tableData.reduce((total, item) => total + Number(item.todayConsume), 0).toFixed(2);
    },
    totalYesConsume() {
      return this.tableData.reduce((total, item) => total + Number(item.yesConsume), 0).toFixed(2);
    }
  },
  methods: {
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        this.fjcookie = response.data.data.records[1].hdcookie
        await       this.getData()

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },

    // Summary method for calculating totals
    summaryMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'; // Display "Total" in the first column
        } else {
          sums[index] = data.reduce((sum, row) => {
            // Ensure we get a valid numeric value for the summation
            const value = Number(row[column.property]);
            return sum + (isNaN(value) ? 0 : value);
          }, 0);
          sums[index] = sums[index].toFixed(2); // Ensure the sum is formatted to 2 decimal places
        }
      });
      return sums;
    },

    // Filter table data based on selected option
    filterResults() {
      const allowedUnames = ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','詹思城','张爱','黄加龙'];
      const kehu = ['福建追书浙江端口', '生米', '千堆雪', '福建追书福建端口'];
      const fjz =['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','福建代运营','詹思城','张爱','黄加龙'];
      const fjyz = ['张栖宇', '林俊杰', '黄祥舟'];
      const fjerz = ['周尚安', '吴周莉', '陈慧','詹思城','张爱','黄加龙'];
      const xiaoshou = ['郑伏金', '叶福顺', '翁媚芳','陈曦'];

      if (this.selectedOption === '运营') {
        this.tableData = this.result.filter(item => allowedUnames.includes(item.uname));
      } else if (this.selectedOption === '客户') {
        this.tableData = this.result.filter(item => kehu.includes(item.uname));
      } else if (this.selectedOption === '福建组') {
        this.tableData = this.result.filter(item => fjz.includes(item.uname));
      } else if (this.selectedOption === '福建1组') {
        this.tableData = this.result.filter(item => fjyz.includes(item.uname));
      } else if (this.selectedOption === '福建2组') {
        this.tableData = this.result.filter(item => fjerz.includes(item.uname));
      } else if (this.selectedOption === '全部') {
        this.getData();
      }else if (this.selectedOption === '销售') {
        this.tableData = this.result.filter(item => xiaoshou.includes(item.uname));
      }

    },

    // Fetch data from API
    getData() {
      this.$message.warning('数据查询中，请耐心等候...', 6000);

      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };
      // 第一个 cookie 用于获取今日和昨日数据
      const cookie1 =this.zjcookie
      ; // 第一个cookie

      // 第二个 cookie 用于获取今日和昨日数据
      const cookie2 =this.fjcookie
      ; // 第二个cookie

      Promise.all([
          fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie2),
        fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie2)
      ])
        .then(([todayAll1, yesAll1]) => {
          this.todayAll = todayAll1;
          this.yesAll = yesAll1;
          return Promise.all([
            fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie1),
            fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie1)
          ]);
        })
        .then(([todayAll2, yesAll2]) => {
          this.todayAll = this.todayAll.concat(todayAll2);
          this.yesAll = this.yesAll.concat(yesAll2);

          this.result = this.users.map(user => {
            const todayConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.todayAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            const yesConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.yesAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            return {
              uname: user.uname,
              todayConsume: Number(todayConsume.toFixed(2)),
              yesConsume: Number(yesConsume.toFixed(2))
            };
          });

          this.tableData = this.result;
          this.$message.success('查询成功', 2000);
        })
        .catch(error => {
          console.error("请求数据时出错:", error);
        });
    },
  },
};
</script>

<style scoped>
.el-table {
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}
.el-table th {
  background-color: #f5f7fa;
  color: #606266;
}
.el-table th div {
  text-align: center;
}
.el-table td {
  text-align: right;
}
.el-select {
  width: 200px;
  margin-bottom: 20px;
}
.el-table {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
<style scoped>
h4 {
  margin-bottom: 10px;
}
.border {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}
.container {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/login/fujianAllData.vue